import { render, staticRenderFns } from "./sharesetting.vue?vue&type=template&id=528a104e&scoped=true"
import script from "./sharesetting.vue?vue&type=script&lang=js"
export * from "./sharesetting.vue?vue&type=script&lang=js"
import style0 from "./sharesetting.vue?vue&type=style&index=0&id=528a104e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a104e",
  null
  
)

export default component.exports